/* eslint-disable */
import { REHYDRATE } from 'redux-persist';
import { DELIVERY_PERSIST_KEY } from '../../../Constants/Delivery/Delivery.constants';
import {
  DELIVERIES_ALL_ERROR,
  DELIVERIES_ALL_SUCCESS,
  DELIVERIES_FILTERS_UPDATE,
  DELIVERIES_FIND_BY_DATE_ERROR,
  DELIVERIES_FIND_BY_DATE_SUCCESS,
} from './Deliveries.types';

/** @typedef {EntityServiceData<DeliveryEntity>} State */
/** @typedef {ActionAny} DeliveriesActions */

const DELIVERIES_ENTITY_ID = `docketId`;

/**
 * Create the state for the `deliveriesReducer` before `redux-persist` kicks in
 * @param {EntityService} entityService The `EntityService`
 * @returns {State} The initial state before `redux-persist` kicks in
 */
const createPrePersistDeliveriesState = (entityService) => entityService.create(DELIVERIES_ENTITY_ID).get();

/**
 * Create the `deliveriesReducer`
 * @param {InjectablesForReducer} injectables The _injectable_'s required by this reducer
 * @returns {Reducer<State, DeliveriesActions>} The `deliveriesReducer`
 */
const deliveriesReducer = ({ entityService }) => (state = createPrePersistDeliveriesState(entityService), action) => {
  switch (action.type) {
    case REHYDRATE: {
      if (action.key !== DELIVERY_PERSIST_KEY || action.payload == null) {
        return state;
      }
      const { _persist, ...newState } = action.payload;
      return newState;
    }
    case DELIVERIES_FIND_BY_DATE_ERROR:
    case DELIVERIES_ALL_ERROR: {
      return entityService
        .create(DELIVERIES_ENTITY_ID)
        .loaded()
        .get();
    }
    case DELIVERIES_FIND_BY_DATE_SUCCESS:
    case DELIVERIES_ALL_SUCCESS: {
      return entityService
        .create(DELIVERIES_ENTITY_ID)
        .loaded()
        .addMany(action.payload)
        .get();
    }
    case DELIVERIES_FILTERS_UPDATE: {
      return {
        ...state,
        filters: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default deliveriesReducer;
